<template>
    <div :class="{container: !isMobile, 'hr-wrap': true}">
        <div class="hr-tab">
            <ul>
                <li class="hr-tab-item" :class="{cur: this.index === 0}" @click="showtab(0)">社招频道</li>
                <!-- <li
                    class="hr-tab-item"
                    :class="{cur: this.index === 1, 'tab-item-space': isMobile}"
                    @click="showtab(1)"
                >校招频道</li> -->
            </ul>
        </div>
        <div class="hr-content">
            <div class="hr-content-item" v-show="this.index === 0">
                <h2 class="hr-title">社招流程</h2>
                <div class="hr-process">
                    <img
                        v-if="COMMON.isMobile"
                        src="../../images/picture/hr_social_flow_mobile.png"
                    >
                    <img v-else src="../../images/picture/hr_social_flow.png">
                </div>
                <template v-if="!COMMON.isMobile">
                    <h2 class="hr-title">邮箱联系</h2>
                    <p class="hr-email">
                        <img src="../../images/icon/about_evelope_grey.png" width="20" height="15">
                        <a class="email-btn" href="mailto:hr@annto.com.cn">hr@annto.com.cn</a>
                    </p>
                </template>
                <div class="hr-table">
                    <table>
                        <tr>
                            <th>职位名称</th>
                            <th>业务部门</th>
                            <th>工作地点</th>
                            <th>招聘人数</th>
                            <th>发布时间</th>
                            <th></th>
                        </tr>
                        <tbody v-for="(item, idx) in hr1Data" :key="idx">
                            <tr>
                                <td @click="showDetail(idx)" class="click-td">
                                    <span>{{item.positionName}}</span>
                                    <img
                                        :class="{'arrow':detailIndex !== idx, 'arrow-rotate':detailIndex === idx}"
                                        src="../../images/icon/right_grey.png"
                                    >
                                </td>
                                <td>{{item.businessDepartment}}</td>
                                <td>{{item.jobAddress}}</td>
                                <td>{{item.jobCount}}</td>
                                <td>{{COMMON.formatDate(item.publishDate)}}</td>
                                <td>
                                    <a href="mailto:hr@annto.com.cn" class="submit-btn">立即申请</a>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colspan="6"
                                    class="hr-job-detail"
                                    v-show="detailIndex === idx"
                                    v-html="item.jobContent + (item.qualifications || '')"
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h2 class="hr-title" v-if="COMMON.isMobile">招聘职位</h2>
                <div class="hr-card" v-for="(item, idx) in hr1Data" :key="idx">
                    <div class="card">
                        <div class="info-wrap">
                            <p class="job-name">{{item.positionName}}</p>
                            <p
                                class="job-intro"
                            >{{item.businessDepartment}} | {{item.jobAddress}} | {{item.jobCount}}人</p>
                            <p>{{COMMON.formatDate(item.createTime)}}</p>
                        </div>
                        <span class="btn-wrap">
                            <a class="job-btn" @click="showMDetail(item)">查看</a>
                        </span>
                    </div>
                </div>
                <Pagination v-bind:pageObj.sync="pageObj1"></Pagination>
                <div class="hr-email-mobile" v-if="COMMON.isMobile">
                    <a class="email-btn" href="mailto:hr@annto.com.cn">投递简历到：hr@annto.com.cn</a>
                </div>
            </div>
            <div class="hr-content-item" v-show="this.index === 1">
                <h2 class="hr-title">校招流程</h2>
                <div class="hr-process">
                    <img
                        v-if="COMMON.isMobile"
                        src="../../images/picture/hr_school_flow_mobile.png"
                    >
                    <img v-else src="../../images/picture/hr_school_flow.png">
                </div>
                <h2 class="hr-title">招聘需求</h2>
                <div class="hr-require">
                    <div class="hr-jobs" v-for="(item,index) in campusJob" :key="index">
                        <div class="hr-jobs-title-wrap">
                            <img :src="item.icon">
                            <h3 class="hr-jobs-title">{{item.name}}</h3>
                        </div>
                        <div class="hr-jobs-info">
                            <p class="hr-jobs-count">
                                招聘人数：
                                <strong>{{item.employCount+'人'}}</strong>
                            </p>
                            <p class="major">
                                <!-- <span>物流管理</span>
                                <span>物流工程</span>
                                <span>交通运输</span>-->
                                {{item.summary}}
                            </p>
                        </div>
                    </div>
                </div>
                <h2 class="hr-title" v-if="!COMMON.isMobile">简历投递</h2>
                <div class="hr-contact-wrap" v-if="!COMMON.isMobile">
                    <div class="hr-contact">
                        <div class="live">
                            <p>宣讲会现场投递</p>
                        </div>
                        
                        <p class="email">
                            <a class="email-btn" href="mailto:hr@annto.com.cn">
                                <img src="../../images/icon/about_evelope_white.png"> hr@annto.com.cn
                            </a>
                        </p>
                    </div>
                    <p :class="{remark: isMobile}">投递备注：面试城市+学校+专业+姓名+联系方式</p>
                </div>
                <h2 class="hr-title">宣讲会信息</h2>
                <div class="hr-table">
                    <table>
                        <tr>
                            <th>城市</th>
                            <th>宣讲学校</th>
                            <th>宣讲日期</th>
                            <th>宣讲时间</th>
                            <th>宣讲教室/会议室地址</th>
                        </tr>
                        <tr v-for="(item, idx) in hr2Data" :key="idx">
                            <td>{{item.seminalCity}}</td>
                            <td>{{item.seminalCampus}}</td>
                            <td>{{COMMON.formatDate(item.semialDate)}}</td>
                            <td>{{COMMON.formatTime(item.semialStartTime) + '-' + COMMON.formatTime(item.semialEndTime)}}</td>
                            <td>{{item.semialAddress}}</td>
                        </tr>
                    </table>
                </div>
                <div class="hr-card" v-for="(item, idx) in hr2Data" :key="idx">
                    <div class="row">
                        <p class="job-name">{{item.seminalCampus}}</p>
                        <p class="job-count">城市：
                            <em>{{item.seminalCity}}</em> 地址：
                            <em>{{item.semialAddress}}</em>
                        </p>
                        <p class="job-address width100">时间：
                            <em>
                                {{COMMON.formatDate(item.semialDate)}}
                                {{COMMON.formatTime(item.semialStartTime) + '-' + COMMON.formatTime(item.semialEndTime)}}
                            </em>
                        </p>
                    </div>
                </div>
                <Pagination v-bind:pageObj.sync="pageObj2"></Pagination>
            </div>
        </div>
        <div :class="{'hr-detail-bg': isMobile, 'hr-detail-content': isShowMDetail}">
            <div class="top-line">
                <a class="close" @click="isShowMDetail = false">&nbsp;</a>
            </div>
            <div class="title-line">{{positionName}}</div>
            <div class="content-line" v-html="jobContent"></div>
        </div>
    </div>
</template>

<style lang="less">
@import "./style/hr.less";
</style>

<script>
import Pagination from '../common/pagination';
import config from '@/config/env.js';
export default {
    metaInfo: {
        title: '企业招聘-安得智联'
    },
    data() {
        return {
            curPage: 0,
            index: 0,
            detailIndex: 0,
            isMobile: this.COMMON.isMobile,
            COMMON: this.COMMON,
            pageObj1: {
                curPage: 1,
                pagesize: 10,
                total: 0
            },
            pageObj2: {
                curPage: 1,
                pagesize: 10,
                total: 0
            },
            hr1Data: [],
            hr2Data: [],
            positionName: '',
            jobContent: '',
            isShowMDetail: false,
            campusJob: []
        };
    },
    computed: {
        page1: function() {
            this.showDetail(0);
            return this.pageObj1.curPage;
        },
        page2: function() {
            return this.pageObj2.curPage;
        }
    },
    activated() {
        this.getData(1, `${config.reqiestUrl}/api-portal/public/portal/social/recruitment/page`);
        this.getData(1, `${config.reqiestUrl}/api-portal/public/portal/campus/seminar/page`);
        this.getData(1, `${config.reqiestUrl}/api-portal/public/portal/campus/recruit/page`);
    },
    methods: {
        showtab(index) {
            this.index = index;
            if (index === 0) {
                this.$router.push({
                    name: 'hr',
                    params: { page: this.pageObj1.curPage },
                    query: { page: this.pageObj1.curPage }
                });
            }

            if (index === 1) {
                this.$router.push({
                    name: 'hr',
                    params: { page: this.pageObj2.curPage },
                    query: { page: this.pageObj2.curPage }
                });
            }
        },
        showDetail(index) {
            this.detailIndex = index;
        },
        showMDetail(item) {
            this.positionName = item.positionName;
            this.jobContent = item.jobContent + (item.qualifications || '');
            this.isShowMDetail = true;
        },
        getData(page, url) {
            var self = this;
            this.$http
                .get(url, {
                    params: {
                        pageNo: page,
                        pageSize: 10
                    }
                })
                .then(function(response) {
                    if (
                        response.data &&
                        response.data.data &&
                        response.data.data.list
                    ) {
                        if (url === `${config.reqiestUrl}/api-portal/public/portal/social/recruitment/page`) {
                            self.hr1Data = response.data.data.list;
                            self.pageObj1.curPage = page;
                            self.pageObj1.total = response.data.data.totalCount;
                        }

                        if (url === `${config.reqiestUrl}/api-portal/public/portal/campus/seminar/page`) {
                            self.hr2Data = response.data.data.list;
                            self.pageObj2.curPage = page;
                            self.pageObj2.total = response.data.data.totalCount;
                        }
                        if (url === `${config.reqiestUrl}/api-portal/public/portal/campus/recruit/page`) {
                            self.campusJob = response.data.data.list;
                        }
                    }
                });
        }
    },
    watch: {
        page1: function(page) {
            this.getData(page, `${config.reqiestUrl}/api-portal/public/portal/social/recruitment/page`);
            this.$router.push({
                name: 'hr',
                params: { page: page },
                query: { page: page }
            });
        },
        page2: function(page) {
            this.getData(page, `${config.reqiestUrl}/api-portal/public/portal/campus/seminar/page`);
            this.$router.push({
                name: 'hr',
                params: { page: page },
                query: { page: page }
            });
        }
    },
    components: {
        Pagination
    }
};
</script>